<template>
  <v-dialog 
    v-model="dialog" 
    class="ch-dialog" 
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-lock-open fa-fw"></i>
          <span class="title">NEW DOORLOCK</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">HOTEL *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="hotel"
                    :rules="hotelRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">REF ID *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="ref_id"
                    :rules="ref_idRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">TYPE *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="type"
                    :rules="typeRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createDoorlock"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { doorlocksEventBus } from '@/components/admin/doorlocks/doorlocksEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        hotel: null,        // NOTE: hotel이 선언되지 않아서 에러발생하여 선언함
        hotel_id: null,
        type: null,
        ref_id: null,
        name: null,
        // NOTE: Dialog
        createDialog: false,
        hotelRules: [
          v => (v === 0) || !!v || 'Please input Hotel',
        ],
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        ref_idRules: [
          v => (v === 0) || !!v || 'Please input Ref ID',
        ],
        typeRules: [
          v => (v === 0) || !!v || 'Please input Type',
        ],
      };
    },
    methods: {
      createDoorlock() {
        const params = {
          email: this.email,
          password: this.password,
          name: this.name,
        };
        api.createDoorlock(params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            doorlocksEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.createDialog = false;
        });
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      openCreateDialog() {
        this.createDialog = true;
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
    },
    mounted() {
      doorlocksEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/CreateDoorlock.vue